export default __webpack_public_path__ + "imgs/39cb3d4b62e43ce2f99c8826587cd67f.mp4";